// extracted by mini-css-extract-plugin
export var alternate = "_b-j";
export var black = "_b-6";
export var blue = "_b-f";
export var blueLight = "_b-e";
export var brand = "_b-8";
export var darkMode = "_b-b";
export var error = "_b-a";
export var gray = "_b-5";
export var grayBlue = "_b-d";
export var iconWrapper = "_b-3";
export var inactive = "_b-7";
export var indigo = "_b-g";
export var orange = "_b-i";
export var pink = "_b-h";
export var primary = "_b-0";
export var purple = "_b-9";
export var success = "_b-4";
export var warning = "_b-c";
export var white = "_b-1";
export var whiteSuccess = "_b-2";